var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"arrow":_vm.viewList.length > 1 ? _vm.arrow : 'never',"indicator-position":_vm.viewList.length > 1 ? 'outside': 'none'}},_vm._l((_vm.viewList),function(item,index){return _c('el-carousel-item',{key:index},[_vm._t("content",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }